import { Injectable, NgZone } from '@angular/core';
import { tap, finalize } from 'rxjs/operators';
import {
  Auth, GoogleAuthProvider, signInWithPopup, FacebookAuthProvider,
  TwitterAuthProvider, GithubAuthProvider, OAuthProvider, AuthProvider, signInAnonymously,
  signOut
} from '@angular/fire/auth';
import { LoginService } from 'app/shivam/login/login.service';
import { Router } from '@angular/router';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { WindowRefService } from 'app/shivam/added-pooja-list/WindowRef.service';
import { AFTER_LOGIN_ACTION } from 'app/shivam/model/login-enum';
import { CurrentUser } from 'app/shivam/model/current-user';
import { ToasterService } from 'app/shivam/services/toaster.service';
import { HttpClient } from '@angular/common/http';
import { GenericResponse } from 'app/shivam/model/genericResponse';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  loading = false;
  currentUser;
  constructor(private afAuth: Auth,
    private loginService: LoginService, private toastr: ToasterService,
    private router: Router, private ngZone: NgZone,
    private http: HttpClient,
    private win: WindowRefService) {
  }
  loginCompleted = new Subject();
  afterLogin = new BehaviorSubject(null);
  afterSocioLogin = new Subject();
  otpError = new Subject();
  getCurrentuser() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  async _signInAnonymously(backToUrl): Promise<void> {
    await signInAnonymously(this.afAuth)
      .then((user) => {
        const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('user >> ', user);
        if (currentUser) {
          this.verifyEmail(user.user.email);
        } else {
          const obj = {
            provider: 'ANONYMOUS',
            email: user.user.email,
            phoneNo: '+919898989898',
            userName: Object(user.user).uid,
            socialId: Object(user.user).uid,
            firstName: Object(user.user).displayName,
            lastName: Object(user.user).displayName,
            profilePicUrl: user.user.photoURL
          };

          this.loginService.socialMediaLogin(obj)
            .pipe(tap(() => this.loading = true), finalize(() => this.loading = false))
            .subscribe(response => {
              if (response.status === 'SUCCESS') {
                localStorage.setItem('currentUser', JSON.stringify(response.result));
                localStorage.setItem('condition', JSON.stringify('true'));
                // this.loginCompleted.next(response.status);
                const _currentUser = response.result;
                if (!_currentUser.phoneNo) {
                  this.afterSocioLogin.next(AFTER_LOGIN_ACTION.MOBILE_OTP);
                } else {
                  this.loginCompleted.next(response.status);
                }
                this.ngZone.run(() => {
                  if (backToUrl === 'annadanam') {
                    this.getCurrentuser();
                    this.router.navigate(['annadanam']);
                  }
                  if (backToUrl === 'donation') {
                    this.getCurrentuser();
                    this.router.navigate(['donation']);
                  }
                  if (backToUrl === 'added-pooja-list') {
                    this.getCurrentuser();
                    this.router.navigate(['added-pooja-list']);
                  }
                  else {
                    this.router.navigate(['pooja-booking']);
                  }
                });
              }
            });
        }
      })
      .catch(error => {
        this.loginCompleted.next('ERROR');
        this.loading = false;
        if (error.code === 'auth/account-exists-with-different-credential') {
          this.toastr.error(`An account', ${error.email}, 'trying to login using', ${error.credential.signInMethod},
              'already exists, but used different sign-in credentials. Please Sign in using a provider associated with this email address.`, 'FAILED');
        }
        else {
          this.toastr.error(`${error.message}`, 'FAILED')
        }
      });
  }

  async signInWithSocial(providerName: string, backToUrl): Promise<void> {
    this.loading = true;
    let provider: AuthProvider;
    if (providerName === 'GOOGLE') {
      provider = new GoogleAuthProvider();
    } else if (providerName === 'FACEBOOK') {
      provider = new FacebookAuthProvider();
    } else if (providerName === 'TWITTER') {
      provider = new TwitterAuthProvider();
    } else if (providerName === 'GITHUB') {
      provider = new GithubAuthProvider();
    } else if (providerName === 'YAHOO') {
      provider = new OAuthProvider('yahoo.com');
    } else if (providerName === 'MICROSOFT') {
      provider = new OAuthProvider('microsoft.com');
    }
    await signInWithPopup(this.afAuth, provider)
      .then((user) => {
        const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log('user >> ', user);
        if (currentUser) {
          this.verifyEmail(user.user.email);
        } else {
          const obj = {
            provider: providerName,
            email: user.user.email,
            userName: user.user.displayName,
            socialId: Object(user.user).id,
            firstName: Object(user.user).displayName,
            lastName: Object(user.user).family_name,
            profilePicUrl: user.user.photoURL
          };

          this.loginService.socialMediaLogin(obj)
            .pipe(tap(() => this.loading = true), finalize(() => this.loading = false))
            .subscribe(response => {
              if (response.status === 'SUCCESS') {
                localStorage.setItem('currentUser', JSON.stringify(response.result));
                localStorage.setItem('condition', JSON.stringify('true'));
                // this.loginCompleted.next(response.status);
                const _currentUser = response.result;
                if (!_currentUser.phoneNo) {
                  this.afterSocioLogin.next(AFTER_LOGIN_ACTION.MOBILE_OTP);
                } else {
                  this.loginCompleted.next(response.status);
                }
                this.ngZone.run(() => {
                  if (backToUrl === 'annadanam') {
                    this.getCurrentuser();
                    this.router.navigate(['annadanam']);
                  }
                  if (backToUrl === 'donation') {
                    this.getCurrentuser();
                    this.router.navigate(['donation']);
                  }
                  if (backToUrl === 'added-pooja-list') {
                    this.getCurrentuser();
                    this.router.navigate(['added-pooja-list']);
                  }
                  else {
                    this.router.navigate(['pooja-booking']);
                  }
                });
              }
            });
        }
      })
      .catch(error => {
        this.loginCompleted.next('ERROR');
        this.loading = false;
        if (error.code === 'auth/account-exists-with-different-credential') {
          this.toastr.error(`An account', ${error.email}, 'trying to login using', ${error.credential.signInMethod},
            'already exists, but used different sign-in credentials. Please Sign in using a provider associated with this email address.`, 'FAILED');
        }
        else {
          this.toastr.error(`${error.message}`, 'FAILED')
        }
      });
  }

  isLoggedIn(): boolean {
    this.afAuth.onAuthStateChanged(res => {
      if (res && res.uid) {
        return true;
      } else {
        return false;
      }
    });
    return false;
  }

  verifyEmail(email) {
    const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'))
    if (currentUser) {
      this.loginService.verifyEmailSocialMediaOnline(email)
        .pipe(tap(() => this.loading = true), finalize(() => this.loading = false))
        .subscribe(response => {
          if (response.result) {
            localStorage.setItem('condition', JSON.stringify('true'));
            currentUser.email = email;
            currentUser.emailVerification = 'true';
            localStorage.removeItem('currentUser');
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            this.loginCompleted.next(response.status);
          }
        });
    }
  }

  verifyOTPLogin(formValue, isOtpLogin = false) {
    this.loading = true;
    this.win.nativeWindow.confirmationResult
      .confirm(formValue.otp)
      .then(result => {
        const currentUser: CurrentUser = JSON.parse(localStorage.getItem('currentUser'))
        let obj;
        if (currentUser) {
          this.loginService.verifyPhoneSocialMediaOnline(result.user.phoneNumber)
            .pipe(tap(() => this.loading = true), finalize(() => this.loading = false))
            .subscribe(response => {
              if (response.result) {
                localStorage.setItem('condition', JSON.stringify('true'));
                currentUser.phoneNo = result.user.phoneNumber;
                currentUser.phoneVerification = 'true';
                localStorage.removeItem('currentUser');
                localStorage.setItem('currentUser', JSON.stringify(currentUser));
                this.loginCompleted.next('SUCCESS');
              }
            });
        } else {
          // console.log('verrrrrrrr>', result);
          obj = {
            provider: result.providerId?.toUpperCase(),
            userName: result.user.phoneNumber,
            firstName: formValue.name ?? result.user.phoneNumber
          };
          obj.phoneNumber = result.user.phoneNumber;
          obj.isOtpLogin = isOtpLogin;
          // console.log('verrrrrrrr>', result, '>>',obj);
          this.loginService.socialMediaLogin(obj)
            .pipe(tap(() => this.loading = true), finalize(() => this.loading = false))
            .subscribe(response => {
              console.log('res', response);
              if (response.status === 'SUCCESS') {
                localStorage.setItem('currentUser', JSON.stringify(response.result));
                localStorage.setItem('condition', JSON.stringify('true'));
                if (response.result.emailVerification !== 'true' && !response.result.email) {
                  this.afterSocioLogin.next(AFTER_LOGIN_ACTION.EMAIL_VERIFICATION);
                } else {
                  this.loginCompleted.next('SUCCESS');
                }
              }
            });
        }
      }).catch(error => {
        // console.log('error>>', error);
        this.toastr.warning('Please enter valid OTP', 'LOGIN ERROR');
        this.loading = false;
        this.otpError.next(error)
      });
  }
  submitEmail(email, verifiedOrOtp?): Observable<GenericResponse<any>> {
    const payload = verifiedOrOtp !== undefined ? String(verifiedOrOtp) : '';
    return this.http.post<GenericResponse<any>>('verifyemail/online/' + email, payload)
  }
  logout() {
    signOut(this.afAuth).then(() => { });
  }

}
